import React from 'react';
import c from 'classnames';
import { useTranslation } from 'react-i18next';

import { CoreLink } from '@uncinc/react-drupal-core';

import { PROJECT_TYPE_DAY_PROGRAM, PROJECT_TYPE_SCHOOL } from '../../config/constants';
import Card from '../Card';
import { ProjectCardProps } from '../Card/types';

import './style.scss';

const ProjectCard: React.FC<ProjectCardProps> = (props) => {
  const {
    title,
    status,
    type,
    image,
    link,
    className,
    projectType,
    organization,
    address,
  } = props;

  const { t } = useTranslation();

  const classNames = c('ProjectCard', `ProjectCard--${projectType}`, 'u-focus-ring--within', 'u-link-box--before', className);

  return (
    <Card className={classNames}>
      <Card.Content>
        <Card.Title title={title} />

        {(projectType === PROJECT_TYPE_SCHOOL) && (
          <>
            <Card.Subtitle subtitle={status} />
            <Card.Subtitle subtitle={type.join(', ')} />
          </>
        )}

        {(projectType === PROJECT_TYPE_DAY_PROGRAM) && (
          <>
            <Card.Subtitle className="ProjectCard__organization" subtitle={organization} />
            <Card.Subtitle className="ProjectCard__address" subtitle={address} />
          </>
        )}
      </Card.Content>

      <Card.Image image={image} />

      <CoreLink
        className="ProjectCard__link"
        href={link}
        title={t(`components.project_card.link.${projectType}`)}
      />
    </Card>
  );
};

export default ProjectCard;
